import { jsx as i } from "@emotion/react/jsx-runtime";
import p, { chipClasses as a } from "@mui/material/Chip";
const c = a, o = ({ ...s }) => /* @__PURE__ */ i(p, { ...s });
o.displayName = "Chip";
export {
  o as C,
  c
};
